import { z } from "zod";

/**
 * Geometry source option from GET /{entity}/geometry-sources
 * (Job / Asset / Ticket / Record — lists are identical).
 */
export const GeometrySourceDisplaySchema = z.object({
	name: z.string(),
	value: z.string(),
});

export const GeometrySourcesArraySchema = z.array(GeometrySourceDisplaySchema);

export type GeometrySourceDisplay = z.infer<typeof GeometrySourceDisplaySchema>;

/**
 * GPS method option from GET /{entity}/gps-methods
 * (Job / Asset / Ticket / Record — lists are identical).
 */
export const GpsMethodDisplaySchema = z.object({
	name: z.string(),
	value: z.string(),
});

export const GpsMethodsArraySchema = z.array(GpsMethodDisplaySchema);

export type GpsMethodDisplay = z.infer<typeof GpsMethodDisplaySchema>;

/** Canonical geometrySource values from the API catalog (for mapping helpers). */
export const GeometrySourceValue = {
	Gps: "GPS",
	ManualEntry: "Manual Entry",
	Geocoded: "Geocoded",
	MapDraw: "Map Draw",
} as const;

export type GeometrySourceValue =
	(typeof GeometrySourceValue)[keyof typeof GeometrySourceValue];

/** Canonical gpsMethod values from the API catalog (for mapping helpers). */
export const GpsMethodValue = {
	DeviceGps: "Device GPS",
	BluetoothRtk: "Bluetooth RTK",
} as const;

export type GpsMethodValue =
	(typeof GpsMethodValue)[keyof typeof GpsMethodValue];
